/*
 *
 * PasswordRecovery actions
 *
 */

import {
  RECOVER_WATCHER,
  RECOVER_SUCCESS,
  RECOVER_FAILED,
  RESET_RECOVER,
} from "./constants"

export function recoverWatcher(email) {
  return {
    type: RECOVER_WATCHER,
    payload: email,
  }
}

export function recoverFailed(error) {
  return {
    type: RECOVER_FAILED,
    payload: error,
  }
}

export function recoverSuccess() {
  return { type: RECOVER_SUCCESS }
}

export function resetRecover() {
  return { type: RESET_RECOVER }
}
